import { Entity, EntityRepositoryType, PrimaryKey, Property } from '@mikro-orm/postgresql'
import { EntityRepository } from '@mikro-orm/postgresql'
import { BaseEntity } from '../core/core.entities'

class TicketOption2SalesChannelsAssignmentRepository extends EntityRepository<TicketOption2SalesChannelsAssignment> {}

/**
 * Maps ticket options to specific sales channels and reseller categories
 * This entity stores custom assignments for ticket options that override
 * the default client-level sales channel assignments
 */
@Entity({ repository: () => TicketOption2SalesChannelsAssignmentRepository })
export class TicketOption2SalesChannelsAssignment extends BaseEntity {
	[EntityRepositoryType]?: TicketOption2SalesChannelsAssignmentRepository

	/**
	 * The product ID from Content Manager - part of composite primary key
	 */
	@PrimaryKey()
	productId: string

	/**
	 * The client ID this assignment belongs to - part of composite primary key
	 */
	@PrimaryKey()
	clientId: string

	/**
	 * The ticket option ID from the product in Content Manager - part of composite primary key
	 */
	@PrimaryKey()
	ticketOptionId: string

	/**
	 * Array of sales channel IDs that this ticket option should be available on
	 */
	@Property({ type: 'text[]' })
	salesChannelIds: string[]

	/**
	 * Array of reseller category IDs for reseller channels
	 */
	@Property({ type: 'text[]' })
	resellerCategoryIds: string[]

	constructor(productId: string, clientId: string, ticketOptionId: string) {
		super()
		this.productId = productId
		this.clientId = clientId
		this.ticketOptionId = ticketOptionId
		this.salesChannelIds = []
		this.resellerCategoryIds = []
	}
}
